import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e26ca6ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "log-title" }, [
  /*#__PURE__*/_createTextVNode(" 操作记录 "),
  /*#__PURE__*/_createElementVNode("span", null, "通过查看登录时间、登录地点和设备可以判断账号是否正常")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_table, {
      data: _ctx.logsList,
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "登录时间",
          prop: "time",
          width: "250",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "城市",
          prop: "city",
          width: "250",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "IP",
          prop: "ip",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "登录设备",
          prop: "device",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作系统",
          prop: "system",
          align: "center"
        })
      ]),
      _: 1
    }, 8, ["data"])
  ]))
}